// import React, { useEffect, useState } from 'react';
// import { FaCheckCircle } from 'react-icons/fa';
// import AdminAppBody from '../../../../components/admin/AdminAppBody';
// import useApiCallHooks from '../../../../hooks/useApiCallHooks';

// const RoadMap = () => {
//   const [response, loading, error, callAPI, statusCode] = useApiCallHooks();
//   const [roadmapData, setRoadmapData] = useState([]);

//   useEffect(() => {
//     callAPI('get', 'student/get-student-road-map');
//   }, []);

//   useEffect(() => {
//     if (response && response.data) {
//       setRoadmapData(response.data); // This is your "data" array from API
//     }
//   }, [response]);

//   return (
//     <AdminAppBody
//     loading={loading}
//       content={
//         <div className="container py-5 text-center">
//           <h3 className="fw-bold">Your Personalized Career Roadmap</h3>
//           <p className="text-muted">
//             Here's your customized learning journey to become a <strong>React</strong> developer
//           </p>

//           <div className="row justify-content-center  mt-4">
           
//             {roadmapData.map((section, index) => (
//               <div
//                 key={index}
//                 className="col-12 col-sm-6 col-md-4 col-lg-2 m-2 p-3 bg-white rounded shadow-sm"
//               >
//                 <div className="mb-2 fs-3">
//                   <i className="bi bi-lightbulb" />
//                 </div>
//                 <h5 className="fw-semibold mb-3">{section.name}</h5>
//                 <ul className="list-unstyled text-start">
//                   {(section.topics || []).map((topic, idx) => (
//                     <li key={idx} className="d-flex align-items-center mb-2">
//                       <FaCheckCircle className="text-success me-2" />
//                       <span>{topic.name}</span>
//                     </li>
//                   ))}
//                 </ul>
//               </div>
//             ))}
//           </div>
//         </div>
//       }
//     />
//   );
// };

// export default RoadMap;
import React, { useEffect, useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { FaBook } from 'react-icons/fa';
import AdminAppBody from '../../../../components/admin/AdminAppBody';
import useApiCallHooks from '../../../../hooks/useApiCallHooks';

// Animation variants
const roadmapVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.15, duration: 0.5 }
  }),
  hover: { scale: 1.03 },
  tap: { scale: 0.98 }
};

const RoadMap = () => {
  const [response, loading, error, callAPI] = useApiCallHooks();
  const [roadmapData, setRoadmapData] = useState([]);
  const roadmapRef = useRef(null);

  useEffect(() => {
    callAPI('get', 'student/get-student-road-map');
  }, []);

  useEffect(() => {
    if (response?.data) {
      setRoadmapData(response.data);
    }
  }, [response]);

  return (
    <AdminAppBody
      loading={loading}
      content={
        <section className="py-5" ref={roadmapRef}>
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <h2 className="text-center mb-4 fw-bold">Your Personalized Career Roadmap</h2>
                <p className="text-center text-muted mb-5">
                  Here's your customized learning journey to become a Full Stack Developer
                </p>
<div className="row justify-content-center">
  {roadmapData.map((section, index) => (
    <motion.div
      key={index}
      className="col-lg-3 col-md-4 col-sm-6 mb-4" // 4 per row on large screens
      custom={index}
      initial="hidden"
      whileInView="visible"
      whileHover="hover"
      whileTap="tap"
      viewport={{ once: true, margin: "0px 0px -100px 0px" }}
      variants={roadmapVariants}
    >
      <div className="card shadow text-center roadmap-box p-3 h-100">
        {/* Book icon */}
        <div className="text-primary fs-3 mb-2">
          <i className="bi bi-lightbulb text-dark" />
        </div>

        <h5 className="fw-bold my-2">{section.name}</h5>

        <ul className="list-unstyled text-start small">
          {section.topics?.map((topic, tIndex) => (
            <li key={tIndex}>✅ {topic.name}</li>
          ))}
        </ul>
      </div>
    </motion.div>
  ))}
</div>


              </div>
            </div>
          </div>
        </section>
      }
    />
  );
};

export default RoadMap;



// import React, { useEffect, useState } from 'react';
// import AdminAppBody from '../../../../components/admin/AdminAppBody';
// import useApiCallHooks from '../../../../hooks/useApiCallHooks';
// import { ProgressBar } from 'react-bootstrap';

// const RoadMap = () => {
//   const [response, loading, error, callAPI] = useApiCallHooks();
//   const [roadmapData, setRoadmapData] = useState([]);

//   useEffect(() => {
//     callAPI('get', 'student/get-student-road-map');
//   }, []);

//   useEffect(() => {
//     if (response?.data) {
//       // Add completed field for each topic
//       const dataWithCompletion = response.data.map(section => ({
//         ...section,
//         topics: section.topics?.map(topic => ({ ...topic, completed: false })) || [],
//       }));
//       setRoadmapData(dataWithCompletion);
//     }
//   }, [response]);

//   // Handle topic completion
//   const handleTopicChange = (sectionIndex, topicIndex) => {
//     setRoadmapData(prevData =>
//       prevData.map((section, sIdx) => {
//         if (sIdx === sectionIndex) {
//           const updatedTopics = section.topics.map((topic, tIdx) =>
//             tIdx === topicIndex ? { ...topic, completed: !topic.completed } : topic
//           );
//           return { ...section, topics: updatedTopics };
//         }
//         return section;
//       })
//     );
//   };

//   // Calculate completion %
//   const getCompletionPercentage = (topics) => {
//     if (!topics.length) return 0;
//     const completedCount = topics.filter(t => t.completed).length;
//     return Math.round((completedCount / topics.length) * 100);
//   };

//   return (
//     <AdminAppBody
//       loading={loading}
//       content={
//         <div className="container py-5 text-center">
//           <h3 className="fw-bold">Your Personalized Career Roadmap</h3>
//           <p className="text-muted">
//             Here's your customized learning journey to become a <strong>React</strong> developer
//           </p>

//           <div className="row justify-content-center mt-4">
//             {roadmapData.map((section, sIndex) => (
//               <div key={sIndex} className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4">
//                 <div className="p-3 bg-white rounded shadow-sm h-100">
//                   {/* Section Title */}
//                   <div className="mb-2 fs-4 text-primary">
//                     <i className="bi bi-lightbulb" />
//                   </div>
//                   <h5 className="fw-semibold mb-3">{section.name}</h5>

//                   {/* Progress Bar */}
//                   <ProgressBar
//                     now={getCompletionPercentage(section.topics)}
//                     label={`${getCompletionPercentage(section.topics)}%`}
//                     className="mb-3"
//                   />

//                   {/* Topics List */}
//                   <ul className="list-unstyled text-start">
//                     {section.topics.map((topic, tIndex) => (
//                       <li key={tIndex} className="d-flex align-items-center mb-2">
//                         <input
//                           type="radio"
//                           checked={topic.completed}
//                           onChange={() => handleTopicChange(sIndex, tIndex)}
//                           className="me-2"
//                         />
//                         <span className={topic.completed ? 'text-decoration-line-through text-muted' : ''}>
//                           {topic.name}
//                         </span>
//                       </li>
//                     ))}
//                   </ul>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       }
//     />
//   );
// };

// export default RoadMap;
